<div class="smooth-scrolling">
  <!-- blog-pg-title START -->
  <div class="blog-search-bar-new">
    <div class="row">
      <div class="col-12 d-lg-none d-flex leftSide">
        <div class="bl-search" [formGroup]="blogSearchForm">
          <div class="search-inputbox" (click)="clickSearch()">
            <input type="search" placeholder="Search blog" name="blog-search" id="blog-search" formControlName="search">
            <div class="search-btn"><input type="submit"><img src="assets/images/search-icon-dark.svg" /></div>
          </div>
          <div [ngClass]="show ? 'open-search-bar':''">
            <ul class="scrollbar" *ngIf="mblogResponse && mblogResponse?.data && mblogResponse.data[0]?.id && show; else noData">
              <li *ngFor="let blogList of mblogResponse?.data">
                <span class="search-icon-new"><img src="assets/images/search-black-nav.svg" alt="icon"></span>
                <a (click)="openBlogDetail(blogList)">{{blogList?.title}}</a></li>
            </ul>

            <ng-template #noData>
              <ul *ngIf="show" class="no-data-h">
                <li>
                  <span class="search-icon-new"><img src="assets/images/search-black-nav.svg" alt="icon"></span>
                  <small>No Data Found</small>
                </li>
              </ul>
            </ng-template>
          </div>
          <div [ngClass]="historyShow ? 'open-search-bar':''">
            <ul class="scrollbar" *ngIf="historyShow && arrSearchHistory && arrSearchHistory.length>0">
              <li class="bold">History</li>
              <li *ngFor="let history of arrSearchHistory">
                <span class="search-icon-new"><img src="assets/images/search-history-icon.png" alt="icon"></span>
                <a (click)="openBlogDetail(history)">{{history.title}}</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <section class="blog-pg-title">
    
    <div class="container">
      <owl-carousel-o class="b-titleSlide" [options]="bTitle">
        <ng-template class="fst-title" carouselSlide>
          <h1>
            <span class="w-1">The </span>
            <span class="w-2">Holy</span><br>
            <span class="w-3">Grail </span>
            <span class="w-4">of all</span><br>
            <span class="w-5">things </span>
            <span class="w-6">beauty</span>
          </h1>
        </ng-template>
        <ng-template class="sec-title" carouselSlide>
          <h1>
            <span class="w-1">The </span>
            <span class="w-2">Holy</span><br>
            <span class="w-3">Grail </span>
            <span class="w-4">of all</span><br>
            <span class="w-5">things </span>
            <span class="w-6">beauty</span>
          </h1>
        </ng-template>
        <ng-template class="thd-title" carouselSlide>
          <h1>
            <span class="w-1">The </span>
            <span class="w-2">Holy</span><br>
            <span class="w-3">Grail </span>
            <span class="w-4">of all</span><br>
            <span class="w-5">things </span>
            <span class="w-6">beauty</span>
          </h1>
        </ng-template>
        <ng-template class="for-title" carouselSlide>
          <h1>
            <span class="w-1">The </span>
            <span class="w-2">Holy</span><br>
            <span class="w-3">Grail </span>
            <span class="w-4">of all</span><br>
            <span class="w-5">things </span>
            <span class="w-6">beauty</span>
          </h1>
        </ng-template>
      </owl-carousel-o>
    </div>
  </section>
  <!-- blog-pg-title END -->

  <!-- blog-filter-panel START -->
  <section class="blog-filter-panel mb-3">
    <div class="row align-items-center">
      <div class="col-lg-3 d-lg-flex d-none leftSide">
        <div class="bl-search" [formGroup]="blogSearchForm">
          <div class="search-inputbox" (click)="clickSearch()">
            <input type="search" placeholder="Search blog" name="blog-search" id="blog-search" formControlName="search">
            <div class="search-btn"><input type="submit"><img src="assets/images/search-icon-dark.svg" /></div>
          </div>
          <div [ngClass]="show ? 'open-search-bar':''">
            <ul class="scrollbar" *ngIf="mblogResponse && mblogResponse?.data && mblogResponse.data[0]?.id && show; else noData">
              <li *ngFor="let blogList of mblogResponse?.data">
                <span class="search-icon-new"><img src="assets/images/search-black-nav.svg" alt="icon"></span>
                <a (click)="openBlogDetail(blogList)">{{blogList?.title}}</a></li>
            </ul>

            <ng-template #noData>
              <ul *ngIf="show" class="no-data-h">
                <li>
                  <span class="search-icon-new"><img src="assets/images/search-black-nav.svg" alt="icon"></span>
                  <small>No Data Found</small>
                </li>
              </ul>
            </ng-template>
          </div>
          <div [ngClass]="historyShow ? 'open-search-bar':''">
            <ul class="scrollbar" *ngIf="historyShow && arrSearchHistory && arrSearchHistory.length>0">
              <li class="bold">History</li>
              <li *ngFor="let history of arrSearchHistory">
                <span class="search-icon-new"><img src="assets/images/search-history-icon.png" alt="icon"></span>
                <a (click)="openBlogDetail(history)">{{history.title}}</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-9 rightSide">
        <div class="blog-nav">
          <ul class="scrollbar scrollbar-none">
            <li *ngFor="let cat of mCategoryResponseModal?.data; let i = index" (click)="openBlogList(cat?.id)"><a [ngStyle]="cat?.color ? {'background': cat?.color , 'color' : '#fff'} : {'background': '#d3d3d3' , 'color' : '#000'} " >{{cat?.name}}</a></li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  <!-- blog-filter-panel END -->

  <!-- trending-Main START -->
  <section class="trending-Main" *ngIf="trendingBlogs && trendingBlogs.length > 0">
    <div class="heading">
      <h2>what's<span>trending?</span></h2>
      <div class="sub-title">Here, there and everywhere</div>
    </div>
    <div class="arrow-btn">
    <div class="trending-d">
      <div class="row trending-d-scroll scrollbar-width-none " id="trendingblogs" #trendingblogs>
        <a class="left-arrow-btn" *ngIf="showtrendingBlogLeftArrow"><img (click)="goLeft('trendingblogs')"
          src="assets/images/left-arrow.png" alt=""></a>
          <div class="col-lg-4 col-sm-6 col-12" *ngFor="let trendingBlog of trendingBlogs; let i = index">
              <app-blogs [categoryList]="mCategoryResponseModal?.data" [blog]="trendingBlog"></app-blogs>
          </div>
          <a class="right-arrow-btn" *ngIf="showtrendingBlogRightArrow"><img (click)="goRight('trendingblogs')"
            src="assets/images/right-arrow.png" alt=""></a>
      </div>
    </div>
  </div>
    <div class="view-all bg-c-change" *ngIf="trendingBlogs && trendingBlogs.length > 0">
      <a  class="cta-button cta-button-new outline-btn-dark bg-c-n" (click)="showAllTrending()">View all</a>
    </div>
  </section>
  
  <!-- trending-Main END -->

  <!-- three-box-sections START -->

  <section class="three-box-sections">
    <div>
      <div class="cmn-box" *ngIf="skinCatId?.is_active !== false && skinCareSubCategories && skinCareSubCategories.length > 0">
        <div class="pink-box box-padding" [style]="'background:' + skinCareColor">
          <div class="heading">
            <h4>Skincare<span>101</span></h4>
            <div class="sub-title">What's the fun without 101?</div>
          </div>
          <div class="blog-nav-skincare scrollbar" *ngIf="skinCareSubCategories && skinCareSubCategories.length > 0">
            <ul class="scrollbar-none">
              <li *ngFor="let skinCareSubCategory of skinCareSubCategories; let i = index" (click)="setSubCategory(skinCatId.category_code, skinCareSubCategory.id)"><a
                [ngStyle]="skinCareColor != '#fff' && skinCareSubCategorySelected == skinCareSubCategory.id ? {'background': '#fff', 'color': skinCareColor} : skinCareColor == '#fff' && skinCareSubCategorySelected == skinCareSubCategory.id ?  {'background': '#000', 'color': skinCareColor} : {}">{{skinCareSubCategory?.name}}</a></li>
            </ul>
          </div>
          <!-- no record found text start -->

          <div class="no-record" *ngIf="skinCareBlogs && skinCareBlogs.length < 1" [ngClass]="skinCareColor != '#fff' ? '' : 'c-black'">
            <span>No Records Found!</span>
          </div>
          <!-- no record found text end -->
          <div class="arrow-btn">
          <div class="blog-Slides scrollbar arrow-bg-remove skincare trending-d arrow-fix">
            <div class="row trending-d-scroll scrollbar-width-none width-box-container" id="skincareone" #skincareone>
              <a class="left-arrow-btn" *ngIf="showskincareoneLeftArrow && skinCareBlogs && skinCareBlogs.length > 1"><img (click)="goLeft('skincareone')"
                src="assets/images/left-arrow.png" alt=""></a>
                <div class="col-lg-4 col-sm-6 col-12" *ngFor="let skinCareBlog of skinCareBlogs; let i = index">
                    <app-blogs [categoryList]="mCategoryResponseModal?.data" [blog]="skinCareBlog"></app-blogs>
                </div>
                <a class="right-arrow-btn" *ngIf="showskincareoneRightArrow && skinCareBlogs && skinCareBlogs.length > 1"><img (click)="goRight('skincareone')"
                  src="assets/images/right-arrow.png" alt=""></a>
            </div>
          </div>
        </div>
          <div class="view-all bg-c-change" *ngIf="skinCareBlogs && skinCareBlogs.length > 0">
            <a class="cta-button outline-btn-light  bg-c-b cta-button-new" (click)="openBlogList(skinCatId.id)">View all</a>
          </div>
        </div>
      </div>
      <div class="cmn-box" *ngIf="dyrCatId?.is_active !== false && decodeYourRoutineSubCategories && decodeYourRoutineSubCategories.length > 0">
        <div class="blue-box box-padding" [style]="'background:' + decodeYourRoutineColor">
          <div class="heading heading-3">
            <h4>Decode Your<span>Routine</span></h4>
            <div class="sub-title mt-1">Trust us, it's not that complicated.</div>
          </div>
          <div class="blog-nav-skincare scrollbar"  *ngIf="decodeYourRoutineSubCategories && decodeYourRoutineSubCategories.length > 0">
            <ul class="scrollbar-none">
              <li *ngFor="let decodeYourRoutineSubCategory of decodeYourRoutineSubCategories; let i = index" (click)="setSubCategory(dyrCatId.category_code, decodeYourRoutineSubCategory.id)"><a  [ngStyle]="decodeYourRoutineColor != '#fff' && decodeYourRoutineSubCategorySelected == decodeYourRoutineSubCategory.id ? {'background': '#fff', 'color': decodeYourRoutineColor} : decodeYourRoutineColor == '#fff' && decodeYourRoutineSubCategorySelected == decodeYourRoutineSubCategory.id ? {'background': '#000', 'color': decodeYourRoutineColor} : {}">{{decodeYourRoutineSubCategory?.name}}</a></li>
            </ul>
          </div>
          <div class="no-record" *ngIf="decodeYourRoutineBlogs && decodeYourRoutineBlogs.length < 1" [ngClass]="decodeYourRoutineColor != '#fff' ? '' : 'c-black'">
            <span>No Records Found!</span>
          </div>
          <div class="arrow-btn">
            <div class="blog-Slides scrollbar arrow-bg-remove skincare trending-d arrow-fix">
              <div class="row trending-d-scroll scrollbar-width-none width-box-container" id="decode" #decode>
                <a class="left-arrow-btn" *ngIf="showdecodeLeftArrow && decodeYourRoutineBlogs && decodeYourRoutineBlogs.length > 1"><img (click)="goLeft('decode')"
                  src="assets/images/left-arrow.png" alt=""></a>
                  <div class="col-lg-4 col-sm-6 col-12" *ngFor="let decodeYourRoutineBlog of decodeYourRoutineBlogs; let i = index">
                      <app-blogs [categoryList]="mCategoryResponseModal?.data" [blog]="decodeYourRoutineBlog"></app-blogs>
                  </div>
                  <a class="right-arrow-btn" *ngIf="showdecodeRightArrow && decodeYourRoutineBlogs && decodeYourRoutineBlogs.length > 1"><img (click)="goRight('decode')"
                    src="assets/images/right-arrow.png" alt=""></a>
              </div>
            </div>
          </div>
          <div class="blog-Slides scrollbar arrow-bg-remove skincare " *ngIf="decodeYourRoutineBlogs && decodeYourRoutineBlogs.length > 0">
           </div>
          <div class="view-all bg-c-change" *ngIf="decodeYourRoutineBlogs && decodeYourRoutineBlogs.length > 0">
            <a class="cta-button outline-btn-light bg-c-b" (click)="openBlogList(dyrCatId.id)">View all</a>
          </div>
        </div>
      </div>
      <div class="cmn-box" *ngIf="formensCatId?.is_active !== false && forMensSubCategories && forMensSubCategories.length > 0">
        <div class="blue-box box-padding" [style]="'background:' + forMensColor">
          <div class="heading men-style men-title what-in-text">
            <h2>what's in it for<span>men?</span></h2>
            <div class="text-center">
              <div class="sub-title">Why should girls have all the fun?</div>
            </div>
          </div>
          <div class="blog-nav-skincare scrollbar scrollbar-one" *ngIf="forMensSubCategories && forMensSubCategories.length > 0">
            <ul class="scrollbar-none">
              <li *ngFor="let forMensSubCategory of forMensSubCategories; let i = index" (click)="setSubCategory(formensCatId.category_code, forMensSubCategory.id)"><a [ngStyle]="forMensColor != '#fff' && forMensSubCategorySelected == forMensSubCategory.id ? {'background': '#fff', 'color': forMensColor} : forMensColor == '#fff' && forMensSubCategorySelected == forMensSubCategory.id ?{'background': '#000', 'color': forMensColor} : {}">{{forMensSubCategory?.name}}</a></li>
            </ul>
          </div>
          <div class="no-record" *ngIf="forMensBlogs && forMensBlogs.length < 1" [ngClass]="forMensColor != '#fff' ? '' : 'c-black'">
            <span>No Records Found!</span>
          </div>
          <div class="arrow-btn">
            <div class="blog-Slides scrollbar arrow-bg-remove skincare trending-d arrow-fix" *ngIf="forMensBlogs && forMensBlogs.length > 0">
              <div class="row trending-d-scroll scrollbar-width-none width-box-container" id="formen" #formen>
                <a class="left-arrow-btn" *ngIf="showformenLeftArrow"><img (click)="goLeft('formen')"
                  src="assets/images/left-arrow.png" alt=""></a>
                  <div class="col-lg-4 col-sm-6 col-12" *ngFor="let forMensBlog of forMensBlogs; let i = index">
                    <app-blogs [categoryList]="mCategoryResponseModal?.data" [blog]="forMensBlog"></app-blogs>
                  </div>
                  <a class="right-arrow-btn" *ngIf="showformenRightArrow"><img (click)="goRight('formen')"
                    src="assets/images/right-arrow.png" alt=""></a>
              </div>
            </div>
          </div>
          <div class="blog-Slides scrollbar arrow-bg-remove skincare " *ngIf="decodeYourRoutineBlogs && decodeYourRoutineBlogs.length > 0">
           </div>
          <div class="view-all bg-c-change" *ngIf="forMensBlogs && forMensBlogs.length > 0">
            <a class="cta-button outline-btn-light bg-c-b" (click)="openBlogList(formensCatId.id)">View all</a>
          </div>
        </div>
      </div>
      <div class="cmn-box" *ngIf="beautyCatId?.is_active !== false && smartBeautySubCategories && smartBeautySubCategories.length > 0">
        <div class="blue-box box-padding" [style]="'background:' + smartBeautyColor">
          <div class="heading smart-text">
            <h4><sup>Smart</sup><span>Beauty</span></h4>
            <div class="sub-title">Beauty is complete when its smart.</div>
          </div>
          <div class="blog-nav-skincare" *ngIf="smartBeautySubCategories && smartBeautySubCategories.length > 0">
            <ul class="scrollbar-none">
              <li *ngFor="let smartBeautySubCategory of smartBeautySubCategories; let i = index"  (click)="setSubCategory(beautyCatId.category_code,smartBeautySubCategory.id)"><a [ngStyle]="smartBeautyColor != '#fff' && smartBeautySubCategorySelected == smartBeautySubCategory.id ? {'background': '#fff', 'color': smartBeautyColor} : smartBeautyColor == '#fff' && smartBeautySubCategorySelected == smartBeautySubCategory.id ? {'background': '#000', 'color': '#fff'} : {}">{{smartBeautySubCategory?.name}}</a></li>
            </ul>
          </div>
          <div class="no-record" *ngIf="smartBeautyBlogs && smartBeautyBlogs.length < 1" [ngClass]="smartBeautyColor != '#fff' ? '' : 'c-black'">
            <span>No Records Found!</span>
          </div>
          <div class="arrow-btn">
            <div class="blog-Slides scrollbar arrow-bg-remove skincare trending-d justify-content-center arrow-fix" *ngIf="smartBeautyBlogs && smartBeautyBlogs.length > 0">
              <div class="row trending-d-scroll scrollbar-width-none width-box-container" id="smartbeauty" #smartbeauty>
                <a class="left-arrow-btn" *ngIf="showsmartbeautyLeftArrow"><img (click)="goLeft('smartbeauty')"
                  src="assets/images/left-arrow.png" alt=""></a>
                  <div class="col-lg-4 col-sm-6 col-12" *ngFor="let smartBeautyBlog of smartBeautyBlogs; let i = index">
                    <app-blogs [categoryList]="mCategoryResponseModal?.data" [blog]="smartBeautyBlog"></app-blogs>
                  </div>
                  <a class="right-arrow-btn" *ngIf="showsmartbeautyRightArrow"><img (click)="goRight('smartbeauty')"
                    src="assets/images/right-arrow.png" alt=""></a>
              </div>
            </div>
          </div>
          <div class="blog-Slides scrollbar arrow-bg-remove skincare " *ngIf="smartBeautyBlogs && smartBeautyBlogs.length > 0">
           </div>
          <div class="view-all bg-c-change" *ngIf="smartBeautyBlogs && smartBeautyBlogs.length > 0">
            <a class="cta-button bg-c-b" (click)="openBlogList(beautyCatId.id)">View all</a>
          </div>
        </div>
      </div>
      <div class="cmn-box" *ngIf="hairCatId?.is_active !== false && hairSubCategories && hairSubCategories.length > 0">
        <div class="blue-box box-padding" [ngStyle]="hairColor != '#fff' ? {'background': hairColor} : {'background': ''}">
          <div class="heading hair-go-text">
            <h4><span>Hair</span> we go!</h4>
            <div class="sub-title">Good hair days are not a myth,
              they’re a lifestyle.</div>
          </div>
          <div class="blog-nav-skincare" *ngIf="hairSubCategories && hairSubCategories.length > 0">
            <ul class="scrollbar-none">
              <li *ngFor="let hairSubCategory of hairSubCategories; let i = index" (click)="setSubCategory(hairCatId.category_code, hairSubCategory.id)"><a [ngStyle]="hairColor != '#fff' && hairSubCategorySelected == hairSubCategory.id ? {'background': '#fff', 'color': hairColor} : hairColor == '#fff' && hairSubCategorySelected == hairSubCategory.id ? {'background': '#000', 'color': '#fff'} : {}">{{hairSubCategory?.name}}</a></li>
            </ul>
          </div>
          <div class="no-record c-black mt-lg-4" *ngIf="hairBlogs && hairBlogs.length < 1" >
            <span>No Records Found!</span>
          </div>
          <div class="arrow-btn">
            <div class="blog-Slides scrollbar arrow-bg-remove skincare trending-d justify-content-center arrow-fix" *ngIf="hairBlogs && hairBlogs.length > 0">
              <div class="row trending-d-scroll scrollbar-width-none width-box-container width-box-two" id="hairwego" #hairwego>
                <a class="left-arrow-btn" *ngIf="showhairwegoLeftArrow"><img (click)="goLeft('hairwego')"
                  src="assets/images/left-arrow.png" alt=""></a>
                  <div class="col-lg-4 col-sm-6 col-12"*ngFor="let hairBlog of hairBlogs; let i = index">
                    <app-blogs [categoryList]="mCategoryResponseModal?.data" [blog]="hairBlog"></app-blogs>
                  </div>
                  <a class="right-arrow-btn" *ngIf="showhairwegoRightArrow"><img (click)="goRight('hairwego')"
                    src="assets/images/right-arrow.png" alt=""></a>
              </div>
            </div>
          </div>  
          <div class="blog-Slides scrollbar arrow-bg-remove skincare " *ngIf="hairBlogs && hairBlogs.length > 0">
           </div>
          <div class="view-all bg-c-change" *ngIf="hairBlogs && hairBlogs.length > 0">
            <a class="cta-button bg-c-b" (click)="openBlogList(hairCatId.id)">View all</a>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- three-box-sections START -->
  <!-- blog-white-section START -->
  <section class="trending-Main" *ngIf="editorsPickBlogs && editorsPickBlogs.length > 0">
    <div class="blog-white-section five-box-heading">
      <div class="heading editor-picks">
        <h4><span>Editor's</span>Picks</h4>
        <div class="sub-title">Curated with love, approved by our editor's picky soul</div>
      </div>
    </div>
    <div class="arrow-btn">
      <div class="trending-d">
        <div class="row trending-d-scroll scrollbar-width-none w-100" id="editor" #editor>
          <a class="left-arrow-btn" *ngIf="showeditorLeftArrow"><img (click)="goLeft('editor')"
            src="assets/images/left-arrow.png" alt=""></a>
            <div class="col-lg-4 col-sm-6 col-12"  *ngFor="let editorsPickBlog of editorsPickBlogs; let i = index">
                <app-blogs [categoryList]="mCategoryResponseModal?.data" [blog]="editorsPickBlog"></app-blogs>
            </div>
            <a class="right-arrow-btn" *ngIf="showeditorRightArrow"><img (click)="goRight('editor')"
              src="assets/images/right-arrow.png" alt=""></a>
        </div>
      </div>
    </div>  
    <div class="view-all bg-c-change editor-btn" *ngIf="editorsPickBlogs && editorsPickBlogs.length > 0">
      <a  class="cta-button cta-button-new outline-btn-dark bg-c-n" (click)="openBlogList(editorsPickBlogs[0].category_id)">View all</a>
    </div>
  </section>
    <section class="trending-Main bath-and-body" *ngIf="(bathBodySubCategories && bathBodySubCategories.length > 0) && (bbCatId?.is_active !== false)">
    <div class="blog-white-section five-box-heading">
      <div class="heading">
        <h4><sup><span>Bath</span></sup>&<span>Body</span></h4>
        <div class="sub-title">Rub-a-dub-dub, pamper in the tub!</div>
      </div>
    </div>
    <div class="blog-nav-skincare scrollbar" >
      <ul class="sub-k scrollbar-none">
        <li *ngFor="let bathBodySubCategory of bathBodySubCategories; let i = index" (click)="setSubCategory(bbCatId?.category_code, bathBodySubCategory.id)"><a [ngStyle]="bathBodyColor != '#fff' && bathBodySubCategorySelected == bathBodySubCategory.id ? {'background': '#fff', 'color': bathBodyColor} : bathBodyColor == '#fff' && bathBodySubCategorySelected == bathBodySubCategory.id ? {'background': '#000', 'color': '#fff'} : {}">{{bathBodySubCategory?.name}}</a></li>
      </ul>
    </div>
    <div class="no-record c-black" *ngIf="bathBodyBlogs && bathBodyBlogs.length < 1">
      <span>No Records Found!</span>
    </div>
    <div class="arrow-btn">
      <div class="trending-d ">
        <div class="row trending-d-scroll scrollbar-width-none w-100 bath-m" id="bathbody" #bathbody *ngIf="bathBodyBlogs && bathBodyBlogs.length > 0">
          <a class="left-arrow-btn" *ngIf="showbathbodyLeftArrow"><img (click)="goLeft('bathbody')"
            src="assets/images/left-arrow.png" alt=""></a>
            <div class="col-lg-4 col-sm-6 col-12" *ngFor="let bathBodyBlog of bathBodyBlogs; let i = index">
                <app-blogs [categoryList]="mCategoryResponseModal?.data" [blog]="bathBodyBlog"></app-blogs>
            </div>
            <a class="right-arrow-btn" *ngIf="showbathbodyRightArrow"><img (click)="goRight('bathbody')"
              src="assets/images/right-arrow.png" alt=""></a>
        </div>
      </div>
     </div> 

    <div class="view-all bg-c-change"  *ngIf="bathBodyBlogs && bathBodyBlogs.length > 0">
      <a  class="cta-button cta-button-new outline-btn-dark bg-c-n" (click)="openBlogList(this.bbCatId.id)">View all</a>
    </div>
  </section>
 
  <div class="bigger-text-section">
    <div class="textWrap">
      <div class="line">
        <span class="gr-text">Beauty</span>
        <span class="light-text">is</span>
        <span class="gr-text personal-text">personal</span>
        <div class="btn-line-01">
          <span class="light-text">so why</span>
          <span class="dark-text">settle</span>
        </div>
        <div class="btn-line-02">
          <span class="light-text">for a</span>
          <span class="light-text">one-size</span>
        </div>
        <span class="gr-text">fits-all approach?</span>
        <div class="book-free-and-the-skin-test-btn">
          <ul class="w-100">
            <li class="new-take-btn">
              <a (click)="commingSoon()">
                take the skin test
                <i class="fa-solid fa-arrow-right arrow-icon"></i>
              </a>
          </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <!-- blog-white-section START -->
</div>
<!-- Footer START -->
<app-footer-bg></app-footer-bg>

<!-- Footer END -->